/**
 * Created by rak on 1/15/2016.
 */
'use strict';

angular.module('trackReporting')
  .controller('RepoGroupSummaryCtrl', function ($scope, widgetSettingsCreatorService, commonTrackService, $timeout, reportService, $stateParams, $filter, $translate, errorHandlingService) {
    //var device = {};
    $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();
    var startDate = '';
    var endDate = '';
    var mainUrlDetails = '&page=map.device.full';
    var column = [];
    var reportOptions = ['eventSummary', 'firstEventSummary', 'excessiveLastCheckIn', 'eventCount', 'digitalInputSummaryReport', 'fleetMotion', 'fleetIdle'];
    $scope.moduleName = 'groupsummary';
    var isGridCreated = false;
    var dateRangePickerSettings = {};
    $scope.isDataAvailable = true;
    var radioCache = commonTrackService.getDataFromLocalStorage('groupSummaryRadioName');
    $scope.radio = {
      name: $stateParams.reportName ? $stateParams.reportName : (radioCache ? radioCache : 'EventSummary')
    };
    var lastlocationWidgetData = commonTrackService.getsetLastLocatioWidgetData();

    $scope.reportComboOption = {
      eventSummary: null,
      firstEventSummary: null,
      excessiveLastCheckIn: null,
      eventCount: null,
      digitalInputSummaryReport: null,
      fleetMotion: null,
      fleetIdle: null
    };

    var _selectedReportOption = '';
    var _selectedReportOptionModel = '';

    $scope.reportHistory = '';
    $scope.reportDetail = {};
    $scope.diableRepoTab = {
      report: true
    };

    $scope.showRepoTab = 0;

    var source =
      {
        datatype: 'array',
        datafields: [],
        localdata: []
      };
    $scope.date = {
      startDate: $stateParams.dateFrom ? new Date($stateParams.dateFrom.replaceAll('-', '/').replace('T', ' ')) : new Date(commonTrackService.formatReportDateTime($filter('date')(new Date(), 'dd/MM/yyyy'), '00:00:00')),
      endDate: $stateParams.dateFrom ? new Date($stateParams.dateTo.replaceAll('-', '/').replace('T', ' ')) : new Date()
    };

    $scope.groupSummaryReportPropList = [{
      _isEnabled: false,
      _reportName: 'EventSummary',
      _idName: 'eventSummaryRadio',
      _translationProp: 'trackReporting.groupsummaryReport.eventSummary',
      _hasOption: true,
      _comboID: 'eventSummaryComboBox',
      _comboModelName: 'eventSummary',
      _comboSettings: 'eventSummarySettings',
      _hasMap: false
    }, {
      _isEnabled: true,
      _reportName: 'FirstEventSummary',
      _idName: 'firstEventSummaryRadio',
      _translationProp: 'trackReporting.groupsummaryReport.firstEventSummary',
      _hasOption: true,
      _comboID: 'firstEventSummaryComboBox',
      _comboModelName: 'firstEventSummary',
      _comboSettings: 'firstEventSummarySettings',
      _hasMap: false
    },
      {
        _isEnabled: false,
        _reportName: 'ExcessiveLastCheckIn',
        _idName: 'excessiveLastCheckInradio',
        _translationProp: 'trackReporting.groupsummaryReport.excessiveLastCheckIn',
        _hasOption: true,
        _comboID: 'excessiveLastCheckInComboBox',
        _comboModelName: 'excessiveLastCheckIn',
        _comboSettings: 'excessiveLastCheckInSettings',
        _hasMap: false
      },
      {
        _isEnabled: false,
        _reportName: 'DeviceLastCheckIn',
        _idName: 'deviceLastCheckInRadio',
        _translationProp: 'trackReporting.groupsummaryReport.deviceLastCheckIn',
        _hasOption: false,
        _hasMap: false
      },
      {
        _isEnabled: true,
        _reportName: 'DeviceNeverCheckIn',
        _idName: 'deviceNeverCheckInRadio',
        _translationProp: 'trackReporting.groupsummaryReport.deviceNeverCheckIn',
        _hasOption: false,
        _hasMap: false
      },
      {
        _isEnabled: false,
        _reportName: 'EventCount',
        _idName: 'eventCountRadio',
        _translationProp: 'trackReporting.groupsummaryReport.eventCount',
        _hasOption: true,
        _comboID: 'eventCountComboBox',
        _comboModelName: 'eventCount',
        _comboSettings: 'eventCountSettings',
        _hasMap: false
      }, {
        _isEnabled: true,
        _reportName: 'EventSessionStatus',
        _idName: 'eventSessionStatusRadio',
        _translationProp: 'trackReporting.groupsummaryReport.eventSessionStatus',
        _hasOption: false,
        _hasMap: false
      },
      {
        _isEnabled: true,
        _reportName: 'PeriodicServiceOdom',
        _idName: 'periodicServiceOdomRadio',
        _translationProp: 'trackReporting.groupsummaryReport.periodicServiceOdom',
        _hasOption: false,
        _hasMap: false
      },
      {
        _isEnabled: true,
        _reportName: 'PeriodicServiceHours',
        _idName: 'periodicServiceHoursRadio',
        _translationProp: 'trackReporting.groupsummaryReport.periodicServiceHours',
        _hasOption: false,
        _hasMap: false
      },
      {
        _isEnabled: true,
        _reportName: 'DistanceTraveled',
        _idName: 'distanceTraveledRadio',
        _translationProp: 'trackReporting.groupsummaryReport.distanceTraveled',
        _hasOption: false,
        _hasMap: false
      }, {
        _isEnabled: false,
        _reportName: 'IgnitionSummaryReport',
        _idName: 'ignitionSummaryReportRadio',
        _translationProp: 'trackReporting.groupsummaryReport.ignitionSummaryReport',
        _hasOption: false,
        _hasMap: false
      }, {
        _isEnabled: false,
        _reportName: 'DigitalInputSummaryReport',
        _idName: 'digitalInputSummaryReportRadio',
        _translationProp: 'trackReporting.groupsummaryReport.digitalInputSummaryReport',
        _hasOption: true,
        _comboID: 'digitalInputSummaryReportComboBox',
        _comboModelName: 'digitalInputSummaryReport',
        _comboSettings: 'digitalInputSummaryReportSettings',
        _hasMap: false
      }, {
        _isEnabled: true,
        _reportName: 'FleetMotion',
        _idName: 'fleetMotionRadio',
        _translationProp: 'trackReporting.groupsummaryReport.fleetMotion',
        _hasOption: true,
        _comboID: 'fleetMotionComboBox',
        _comboModelName: 'fleetMotion',
        _comboSettings: 'fleetMotionSettings',
        _hasMap: false
      },
      {
        _isEnabled: false,
        _reportName: 'FleetIdle',
        _idName: 'fleetIdleRadio',
        _translationProp: 'trackReporting.groupsummaryReport.fleetIdle',
        _hasOption: true,
        _comboID: 'fleetIdleComboBox',
        _comboModelName: 'fleetIdle',
        _comboSettings: 'fleetIdleSettings',
        _hasMap: false
      },
      {
        _isEnabled: true,
        _reportName: 'FuelSummaryReport',
        _idName: 'fuelSummaryReportRadio',
        _translationProp: 'trackReporting.groupsummaryReport.fuelSummaryReport',
        _hasOption: false,
        _hasMap: false
      },
      {
        _isEnabled: true,
        _reportName: 'StatusSummaryCount',
        _idName: 'statusSummaryCountRadio',
        _translationProp: 'trackReporting.groupsummaryReport.statusSummaryCount',
        _hasOption: false,
        _hasMap: false
      },
      {
        _isEnabled: false,
        _reportName: 'UserLogin',
        _idName: 'userLoginRadio',
        _translationProp: 'trackReporting.groupsummaryReport.userLogin',
        _hasOption: false,
        _hasMap: false
      },
      {
        _isEnabled: false,
        _reportName: 'GeozoneNearbyDevices',
        _idName: 'geozoneNearbyDevicesRadio',
        _translationProp: 'trackReporting.groupsummaryReport.geozoneNearbyDevices',
        _hasOption: false,
        _hasMap: false
      },
      {
        _isEnabled: false,
        _reportName: 'GeozoneHotspotReport',
        _idName: 'geozoneHotspotReportRadio',
        _translationProp: 'trackReporting.groupsummaryReport.geozoneHotspotReport',
        _hasOption: false,
        _hasMap: false
      },
      {
        _isEnabled: true,
        _reportName: 'ReportedRefuel',
        _idName: 'reportedRefuelReportRadio',
        _translationProp: 'trackReporting.groupsummaryReport.reportedRefuel',
        _hasOption: false,
        _hasMap: false
      },
      {
        _isEnabled: true,
        _reportName: 'RefuelMileage',
        _idName: 'refuelMileageReportRadio',
        _translationProp: 'trackReporting.groupsummaryReport.refuelMileage',
        _hasOption: false,
        _hasMap: false
      },
      {
        _isEnabled: true,
        _reportName: 'MonthlyVehicleFuelUse',
        _idName: 'MonthlyVehicleFuelUseReportRadio',
        _translationProp: 'trackReporting.groupsummaryReport.monthlyVehicleFuelUse',
        _hasOption: false,
        _hasMap: false
      }
    ];

    var dateRangeCustomEventHandler = {
      eventHandlers: {
        'apply.daterangepicker': function () {
          startDate = $scope.date.startDate._isAMomentObject ? $scope.date.startDate.format('YYYY/MM/DD/HH:mm:ss') : $filter('date')($scope.date.startDate, 'yyyy/MM/dd/HH:mm:ss');
          endDate = $scope.date.startDate._isAMomentObject ? $scope.date.endDate.format('YYYY/MM/DD/HH:mm:ss') : $filter('date')($scope.date.endDate, 'yyyy/MM/dd/HH:mm:ss');
          if ($scope.showRepoTab === 1) {
            $scope.getReport($scope.radio.name, $scope.hasMap, _selectedReportOptionModel);
          }
          /* $timeout(function () {
           $scope.mapUrl = commonTrackService._functionUpdateMapUrl($scope.fleetServerUrl, mainUrlDetails + '&group=' + device.value + '&date_fr=' + startDate + '&date_to=' + endDate);
           }, 0);*/
        }
      }
    };

    commonTrackService.getDatePickerDetails().then(function (settings) {
      $scope.options = commonTrackService.getDateRangePickerSettings(dateRangeCustomEventHandler, commonTrackService.getDateRangePickerRange(settings,$scope.radio.name));
      dateRangePickerSettings = settings;
    });

    var loadFleetServerDetails = function () {
      return commonTrackService.getFleetServerDetails().then(function (fleetServerDetails) {
        $scope.fleetServerUrl = fleetServerDetails.qualifiedServerURL;
        $scope.mapUrl = commonTrackService._functionUpdateMapUrl($scope.fleetServerUrl, mainUrlDetails);
      });
    };

    $scope.repoGroupSettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'description',
      valueMember: 'groupID'
    });


    $scope.eventSummarySettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'displayName',
      valueMember: 'key'
    });

    $scope.firstEventSummarySettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'displayName',
      valueMember: 'key'
    });

    $scope.excessiveLastCheckInSettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'displayName',
      valueMember: 'key'
    });

    $scope.eventCountSettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'displayName',
      valueMember: 'key'
    });

    $scope.digitalInputSummaryReportSettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'displayName',
      valueMember: 'key'
    });

    $scope.fleetMotionSettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'displayName',
      valueMember: 'key'
    });
    $scope.fleetIdleSettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'displayName',
      valueMember: 'key'
    });

    var loaddevice = function () {
      return commonTrackService.getVehicleGroupComboList().then(function (groupList) {
        var cacheData = commonTrackService.getDataFromLocalStorage('groupSummaryReport');
        $scope.repoGroupSettings.source = groupList;
        if ($stateParams.groupId) {
          $scope.repoGroup = $stateParams.groupId;
        } else if (lastlocationWidgetData.selectedVehicleGroup && lastlocationWidgetData.selectedVehicleGroup !== 'all') {
          $scope.repoGroup = lastlocationWidgetData.selectedVehicleGroup;
        } else if (cacheData) {
          $scope.repoGroup = cacheData;
        } else {
          $scope.repoGroup = $scope.repoGroupSettings.source[0].groupID;
        }
      });
    };
    var loadReportOptions = function (name) {
      reportService.getCustomGroupSummaryRepotOptions(name).then(function (reportOptionData) {
        for (var i = 0; i < reportOptionData.length; i++) {
          reportOptionData[i].displayName = $translate.instant('trackReporting.groupsummaryReport.reportComboboxOptions.' + name + '.' + reportOptionData[i].key);
        }
        $scope[name + 'Settings'].source = reportOptionData;
        $scope.reportComboOption[name] = reportOptionData[0].key;
      });
    };

    loadFleetServerDetails().then(function () {
      return loaddevice();
    }).finally(function () {

      for (var i = 0; i < reportOptions.length; i++) {
        loadReportOptions(reportOptions[i]);
      }
      initExport();
      $scope.dataLoadingFinished = true;
      $scope.isCreateCombobox = true;
      $('#grpSumryRepoSpliter').jqxSplitter(reportService.getReportSpliterWithMapPanel());
      $('#' + $scope.overviewGridPrefix + 'groupSummaryReportList').on('bindingcomplete', function () {
        isGridCreated = true;
        $timeout(function () {
          $('#grpSumryRepoSpliter').jqxSplitter('render');
        }, 100);
      });
    });

    $scope.getReport = function (reportName, hasMap, reportOption, event) {
      $scope.mapUrl = '';
      var gridState = reportService.getReportGridState('groupSummaryReport', reportName);
      _selectedReportOptionModel = reportOption;
      $scope.error = false;
      $scope.exportOption = 'HTML';
      $scope.diableRepoTab.report = false;
      $scope.hasMap = hasMap;
      $scope.dataLoadingFinished = false;

      startDate = startDate && !startDate._isAMomentObject ? startDate : $filter('date')($scope.date.startDate._isAMomentObject ? $scope.date.startDate._d : $scope.date.startDate, 'yyyy/MM/dd/HH:mm:ss');
      endDate = endDate && !endDate._isAMomentObject ? endDate : $filter('date')($scope.date.endDate._isAMomentObject ? $scope.date.endDate._d : $scope.date.endDate, 'yyyy/MM/dd/HH:mm:ss');


      _selectedReportOption = $scope.reportComboOption[reportOption] && reportOption ? $scope.reportComboOption[reportOption] : '';
      if ($scope.hasMap) {
        $scope.mapUrl = commonTrackService.getReportMap($scope.fleetServerUrl, reportName, 'group', event ? event.args.item.value : $scope.repoGroup, _selectedReportOption ? _selectedReportOption : '', startDate, endDate);
      }
      var _tmpReportData = null;
      reportService.getGroupReport($scope.moduleName, event ? event.args.item.value : $scope.repoGroup, endDate, startDate, $scope.reportHistory !== reportName ? true : false, reportName, _selectedReportOption !== null ? _selectedReportOption : '').then(function (detailReport) {
        $scope.isDataAvailable = true;
        _tmpReportData = detailReport;
        if ($scope.reportHistory !== reportName) {
          $scope.reportHistory = reportName;
          source.localdata = detailReport.dataList;
          source.sort = commonTrackService.getCustomReportSortFunction($scope.overviewGridPrefix + 'groupSummaryReportList', source);
          column = commonTrackService.getColumnProperties(detailReport.gridSettings.overviewListGrids[0].columnProperties, detailReport.columnTranslation, {
            moduleName: reportName,
            reportModel: 'groupSummaryReport'
          });
          var _additionalProperties = {
            translatedName: $translate.instant('trackReporting.groupsummaryReport.' + reportName.toLoawerCaseAt(0)),
            isDynamicGrid: true,
            dynamicModuleName: reportName
          };
          $scope.gridSettings = commonTrackService.getGridSettings('groupSummaryReport', {
            pagesizeoptions: ['25', '50', '100'],
            pagesize: 25,
            columns: column,
            autosavestate: false,
            height: 670,
            autoloadstate: false
          }, null, _additionalProperties);
          $scope.dataAdapter = new $.jqx.dataAdapter(source);
          $scope.gridSettings.source = $scope.dataAdapter;
          // should be executed only after once successfully creating grid or else 'grid container will be lost', following needed for Jqx 4 changes.
          if (isGridCreated) {
            $('#' + $scope.overviewGridPrefix + 'groupSummaryReportList').jqxGrid({
              source: $scope.dataAdapter,
              columns: column
            });
          }
          $('#' + $scope.overviewGridPrefix + 'groupSummaryReportList').jqxGrid($scope.gridSettings);
        }
        else {
          source.localdata = detailReport.dataList;
          $('#' + $scope.overviewGridPrefix + 'groupSummaryReportList').jqxGrid('updatebounddata', 'data');
        }
      }, function (response) {
        $('#' + $scope.overviewGridPrefix + 'groupSummaryReportList').jqxGrid('clear');
        $scope.reportHistory = '';
        $scope.mapUrl = '';
        if (errorHandlingService.errorForNoAuthorized(response)) {
          $scope.isDataAvailable = false;
        }
      }).finally(function () {
        $timeout(function () {

          $scope.showRepoTab = 1;
          if (!$scope.hasMap) {
            $('#grpSumryRepoSpliter').jqxSplitter(reportService.getReportSplitterWithoutMapPannel());
          } else {
            $('#grpSumryRepoSpliter').jqxSplitter(reportService.getReportSpliterWithMapPanel());
          }

          if (!$scope.isEventRegistered) {
            $('#' + $scope.overviewGridPrefix + 'groupSummaryReportList').on('filter', function () {
              saveGridSate();
            });
            $('#' + $scope.overviewGridPrefix + 'groupSummaryReportList').on('columnresized', function () {
              saveGridSate(reportName);
            });

            $('#' + $scope.overviewGridPrefix + 'groupSummaryReportList').on('columnreordered', function () {
              saveGridSate(reportName);
            });

            $('#' + $scope.overviewGridPrefix + 'groupSummaryReportList').on('sort', function () {
              saveGridSate(reportName);
            });
            $('#' + $scope.overviewGridPrefix + 'groupSummaryReportList').jqxGrid('loadstate', gridState);
            $scope.isEventRegistered = true;
          }

        }, 0);
        //  $('#vehicleDetailReportList').jqxGrid('render');
        $timeout(function () {
          var gridLocalStorageUserSettingKey = reportName + '-' + $scope.overviewGridPrefix + 'groupSummaryReportList';
          reportService.loadReportCustomGridState(_tmpReportData, '#' + $scope.overviewGridPrefix + 'groupSummaryReportList', $scope.gridSettings, gridState , gridLocalStorageUserSettingKey);
        }, 1000);
        column = null;
        $('#' + $scope.overviewGridPrefix + 'groupSummaryReportList').on('rowselect', function (event) {
          if (event.args && event.args.row && event.args.row.timestamp) {
            commonTrackService.iframePostMessage('jsmShowDetailPushpinForRoute_Dsa(' + event.args.row.timestamp + ')', 'groupMap');
          }
        });
      });
    };

    function saveGridSate() {
      var reportSate = $('#' + $scope.overviewGridPrefix + 'groupSummaryReportList').jqxGrid('getstate');
      reportService.setReportGridState('groupSummaryReport', $scope.radio.name, reportSate);
    }

    function initExport() {
      $scope.exportSetting = reportService.getExportSettings();
      $scope.exportSetting.selectedIndex = 0;
      $scope.exportOption = 'HTML';
    }

    $scope.exportChange = function (event) {
      $scope.exportURL = '';
      if (event.args && event.args.item.value !== 'EMail' && event.args.item.value !== 'HTML') {

        $scope.exportURL = commonTrackService.getExportURL($scope.reportHistory, event.args.item.value, 'group', $scope.repoGroup, _selectedReportOption ? _selectedReportOption : '', startDate, endDate);
        reportService.doExport($scope.exportURL, $scope.reportHistory, event.args.item.value);
      } else {
        $scope.exportOption = typeof event === 'object' && event.args && event.args.item.value ? event.args.item.value : event;
        $scope.exportURL = commonTrackService.getExportURL( $scope.reportHistory, event, 'group', $scope.repoGroup, _selectedReportOption ? _selectedReportOption : '', startDate, endDate, $scope.reportDetail.emailAddresses);
        if (!event.args) {
          reportService.doExport($scope.exportURL, $scope.reportHistory, 'EMail');
        }
      }
    };


    $scope.repoGroupComboChange = function (event) {
      var selectItem = event.args.item;
      if (selectItem) {
        commonTrackService.setDataToLocalStorage('groupSummaryReport', selectItem.value);
      }
      if( event.args&& event.args.item.value ){
        $scope.repoGroup = event.args.item.value;
      }
      if ($scope.showRepoTab === 1) {

        $scope.getReport($scope.radio.name, $scope.hasMap, _selectedReportOptionModel, event);
      }
    };
    $scope.$watch('radio.name', function (value) {
      if (value) {
        commonTrackService.setDateRangePickerCustomOptions($scope.options, commonTrackService.getDateRangePickerRange(dateRangePickerSettings,value));
        var range = commonTrackService.getDateRangePickerRange(dateRangePickerSettings,value);
          if(range === commonTrackService.dateRange.SHORT) {
            $scope.date = {
              startDate: moment().clone().startOf('day'),
              endDate: moment()
            };
          } else if (range === commonTrackService.dateRange.MID) {
            $scope.date = {
              startDate: moment().clone().startOf('week'),
              endDate: moment()
            };
          }
        startDate = $scope.date.startDate._isAMomentObject ? $scope.date.startDate.format('YYYY/MM/DD/HH:mm:ss') : $filter('date')($scope.date.startDate, 'yyyy/MM/dd/HH:mm:ss');
        endDate = $scope.date.startDate._isAMomentObject ? $scope.date.endDate.format('YYYY/MM/DD/HH:mm:ss') : $filter('date')($scope.date.endDate, 'yyyy/MM/dd/HH:mm:ss');

        // after new layout 4 $parent is required to keep breadcrump to keep the link ( better solution have to be found)
        $scope.$parent.breadCrumbLabel = $translate.instant('trackReporting.groupSummary') + ' / ' + $translate.instant('trackReporting.groupsummaryReport.' + $scope.radio.name._toLowerCaseAtIndex(0));
        $scope.$parent.$parent.$parent.$parent.breadCrumbLabel = $translate.instant('trackReporting.groupSummary') + ' / ' + $translate.instant('trackReporting.groupsummaryReport.' + $scope.radio.name._toLowerCaseAtIndex(0));
        commonTrackService.setDataToLocalStorage('groupSummaryRadioName', value);
      }
    });

    $scope.cancel = function () {
      $scope.showRepoTab = 0;
    };
    var updateDateRangeInternalDateEvent = $scope.$on('date-range-internalDate-old', function () {
      $scope.options.ranges = commonTrackService.setDateRangePickerCustomOptions($scope.options, commonTrackService.getDateRangePickerRange(dateRangePickerSettings,$scope.radio.name));
      angular.element('#daterange4').trigger('show.daterangepicker');
    });

    $scope.$on('$destroy', function () {
      updateDateRangeInternalDateEvent();
      if ($scope.dataAdapter) {
        delete  $scope.dataAdapter;
      }
      if ($scope.gridSettings && $scope.gridSettings.source) {
        delete $scope.gridSettings.source;
      }
    });
  });



// WEBPACK FOOTER //
// ./.tmp/components/track/reports/groupSummaryReportController.js